import { ProgressBarInner, ProgressBarWrapper } from './styles';

type ProgressBarProps = {
    progressPercentage: number;
};

const ProgressBar = ({ progressPercentage }: ProgressBarProps) => {
    const cappedProgress = Math.max(0, Math.min(100, progressPercentage));

    return (
        <ProgressBarWrapper role="progressbar" aria-valuenow={cappedProgress}>
            <ProgressBarInner style={{ width: `${cappedProgress}%` }} />
        </ProgressBarWrapper>
    );
};

export default ProgressBar;
